import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';

import { ConfigFlagsState } from './configFlagsTypes';
import { CONFIG_FLAGS_INITIAL_STATE, CONFIG_FLAGS_SLICE_NAME } from './configFlagsConsts';
import { fetchConfigFlags } from './configFlagThunks';

const configFlagsSlice = createSlice({
  name: CONFIG_FLAGS_SLICE_NAME,
  initialState: CONFIG_FLAGS_INITIAL_STATE,
  reducers: {
    setConfigFlag: (state, action: PayloadAction<{ flagName: string; value: string }>) => {
      state.values[action.payload.flagName] = action.payload.value;
    },
    resetConfigFlags: () => CONFIG_FLAGS_INITIAL_STATE,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfigFlags.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchConfigFlags.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.values = action.payload;
      })
      .addCase(fetchConfigFlags.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { setConfigFlag, resetConfigFlags } = configFlagsSlice.actions;

export const configFlagsReducer: Reducer<ConfigFlagsState> = configFlagsSlice.reducer;
